// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"aa2afd2e","142":"1edc39ef","390":"def2115b","789":"8df88945"}[chunkId] + ".chunk.js";
};